import { render, staticRenderFns } from "./InternalInformation.vue?vue&type=template&id=945460f2&"
import script from "./InternalInformation.vue?vue&type=script&lang=js&"
export * from "./InternalInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports